/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Formation controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, JobReponse } from "../models";

@Injectable({ providedIn: "root" })
export class FormationService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    importFormationsFromExcel(file: Blob, ies: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<JobReponse>;
    importFormationsFromExcel(file: Blob, ies: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<JobReponse>>;
    importFormationsFromExcel(file: Blob, ies: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<JobReponse>>;
    importFormationsFromExcel(file: Blob, ies: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/import`;

        let params = new HttpParams();
        if (ies != null) {
            params = HttpParamsBuilder.addToHttpParams(params, ies, 'ies');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
